import React, { useContext, useEffect, useState } from 'react';
import { Link } from '@reach/router';
import { FaChevronLeft } from 'react-icons/fa';

import Api from '../../api';

import Layout from '../../components/Layout';
import SEO from '../../components/SEO';
import JobLoading from '../../components/JobLoading';
import Context from '../../providers/Context';

import Job from '../../components/Job';
import JobNotFound from '../../components/jobNotFound';

const OfertaPage = props => {
	const { jobs, dispatch } = useContext(Context);
	const [loading, setLoading] = useState(false);
	const { offerId } = props;

	const [job, setJob] = useState(null);

	const selectJob = () => {
		setLoading(true);
		if (jobs.length === 0) {
			fetchJobs();
		} else {
			findJob();
		}
	};

	const findJob = () => {
		setLoading(true);
		let selected_job = jobs.filter(item => item.slug === offerId);
		setJob(selected_job[0]);
		setLoading(false);
	};

	const fetchJobs = () => {
		const clients = {
			client_id: process.env.REACT_APP_CLIENT_ID,
		};
		Api()
			.post('/get_oferts', { ...clients })
			.then(res => {
				dispatch({ type: `FETCH_JOBS`, payload: [...res.data.data] });
			});
	};

	useEffect(() => {
		selectJob();
	}, [jobs]);

	return (
		<Layout page='ofertas'>
			<SEO title={`Oferta: ${job!== null ? job?.name : ''}`} />
			<div className='w-full text-black pt-0'>
				<div className='container mx-auto w-full p-8'>
					<section className='flex flex-col text-white' id='jobs'>
						<Link
							className='text-alsea-darkblue font-xl px-2 py-3 my-4'
							to='/ofertas'
						>
							<FaChevronLeft className='text-base inline ' />
							<span className='px-4 font-bold text-tcn-dark-blue'>
								Volver a todas las ofertas
							</span>
						</Link>
						{loading && <JobLoading />}
						{ job && job !== null && job !== undefined && <Job job={job} /> }
						{ job === null || job !== undefined || <JobNotFound /> }
					</section>
				</div>
			</div>
		</Layout>
	);
};
export default OfertaPage;
